/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import HeaderPublic from 'components/Header/HeaderPublic';
import Footer from 'components/Footer/Footer';
import pagesStyle from 'assets/jss/material-dashboard-react/layouts/pagesStyle';
import logo from 'assets/img/logo/molecule-72-192917.png';
import withStyles from '@material-ui/core/styles/withStyles';

const AdminPublic = (props) => {
  const { classes, ...rest } = props;
  const bgImage = localStorage.getItem('network_bg_image');
  return (
    <div>
      <HeaderPublic logo={logo} {...rest} />
      <div className={classes.wrapper}>
        <div className={classes.fullPage}>
          <Outlet />
          <Footer white />
          <div
            className={classes.fullPageBackground}
            style={{ backgroundImage: `url(${bgImage})` }}
          />
        </div>
      </div>
    </div>
  );
}


AdminPublic.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(AdminPublic);
